import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { projects } from '../mock';
import Reveal from './Reveal';

const PER_PAGE = 5;

const Projects = () => {
  const pages = Math.ceil(projects.length / PER_PAGE);
  const [page, setPage] = useState(0);
  const start = page * PER_PAGE;
  const items = projects.slice(start, start + PER_PAGE);

  return (
    <section id="projects" className="bg-white py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal variant="up">
          <div className="text-center mb-12">
            <div className="text-[#D4A853] tracking-[0.3em] text-xs font-semibold mb-3">OUR PROJECTS</div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B1430]">Transforming Homes with Smart Lighting</h2>
          </div>
        </Reveal>

        <div className="relative">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {items.map((p, i) => (
              <Reveal key={p.title} variant="scale" delay={i * 100}>
                <div className="project-card group cursor-pointer">
                  <div className="overflow-hidden rounded-lg aspect-[4/3] bg-gray-100">
                    <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                  </div>
                  <div className="text-center mt-3 text-[#0B1430] text-[14px] font-medium">{p.title}</div>
                </div>
              </Reveal>
            ))}
          </div>

          {/* Arrows */}
          <button
            onClick={() => setPage((page - 1 + pages) % pages)}
            className="hidden md:flex absolute -left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white border border-gray-200 shadow-md items-center justify-center hover:border-[#D4A853] hover:text-[#D4A853] transition-colors"
            aria-label="Previous"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            onClick={() => setPage((page + 1) % pages)}
            className="hidden md:flex absolute -right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white border border-gray-200 shadow-md items-center justify-center hover:border-[#D4A853] hover:text-[#D4A853] transition-colors"
            aria-label="Next"
          >
            <ChevronRight size={20} />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {Array.from({ length: pages }).map((_, i) => (
            <button
              key={i}
              onClick={() => setPage(i)}
              className={`dot ${i === page ? 'active' : ''}`}
              aria-label={`Page ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
